/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from 'lodash.debounce';

import * as Actions from "actions";
import {
    TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Container, Typography, Box, Grid, MenuItem, Modal, Backdrop, Fade,
} from "@mui/material";
import UserProductDetail from "components/elements/user/products/UserProductDetail";
import UserProductDetailModal from "components/elements/user/products/UserProductDetailModal";

import MockSearchResults from "components/elements/main/MockSearchResults";
import {H2, H4, H5} from "components/CustomTypography";
import {SearchOutlinedIcon} from "../UserCombinedSearch";

import {
    getCategoryBreadcrum,
    getUserProductSortList,
    getCategoryFromID,
    getLocationMarketFromID,
    getLocationBreadcrum,
    isMarketPlaceOnly,
    isFeatureSupported, getLogo, getPlatform, analyticsTrackPageView, analyticsTrackEvent, getURI
} from "helpers/utils";
import CustomSectionCreator from "components/CustomSectionCreator";
import MobileCategoryNav from "components/mobile-category-nav";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import {useLocation} from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";
import { UnifiedLongPressableObject } from "components/elements/main/UnifiedLongPressableObject";
import UnifiedPullDown from "components/elements/main/UnifiedPullDown";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import UserTryOnItem from "components/elements/user/tryon/UserTryOnItem";

import UnifiedPullToRefresh from "components/elements/main/UnifiedPullToRefresh";

const UserTryoutHistory = (props) => {
  const [state, setState] = useState({
    limit: 20,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
    searchvalue: "Search products",
    isShop: false,
  });

  const [productState, setProductState] = useState("");
  const [productModeState, setProductModeState] = useState("PREVIEW");
  const [optionValues, setOptionValues] = useState([]);

    const [categoryState, setCategoryState] = useState("");
    const [colorState, setColorState] = useState("");
    const [locationState, setLocationState] = useState("");
    const [marketState, setMarketState] = useState("");
    const [typeState, setTypeState] = useState("viewed");
    const [offsetState, setOffsetState] = useState(0);

    const [loadStoryState, setLoadStoryState] = useState(false);
    const [loadIdState, setLoadIdState] = useState("");
    const [currentStoryIndex, setCurrentStoryIndex] = useState(null);
    const [showModalProduct, setShowModalProduct] = useState(null);

    const [hasTriedLoading, setHasTriedLoading] = useState(false);


    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [tryonToDelete, setTryonToDelete] = useState(null);
    const [autoReloadTimer, setAutoReloadTimer] = useState(null);

    const {
        serviceError, reqStatus, isLoadingProducts,
        userMainResetSearchProducts,
        getTryOnHistory, deleteTryOn,
        userMainGetProductInfo,
        products, productdetail, searchkeywords,
        userMainResetProductDetail,
        userMainAddProductToWishlist,
        commonCategoryList, commonColorList, citylocations,
        currency, match, history,
        isLoadingShop, shopId, isShop, marketId, limit, wholesale,
        userDetails, tryonCredits, includeHeader
    } = props;


    const urlparams = useLocation();


    const closeProductModal = () => setShowModalProduct(null);

    useEffect(() => {

        analyticsTrackPageView("/shopping/tryout", "Main Products Tryouts");

        // Get a specific query parameter
        const checkStory = new URLSearchParams(urlparams.search).get('ls');

        if (checkStory) {
            setLoadStoryState(true);
        }

        const loadIndex = new URLSearchParams(urlparams.search).get('li');

        if (loadIndex) {
            setLoadIdState(loadIndex);
        }


        setHasTriedLoading(false);
        getTryOnHistory(shopId, "");

    }, []);


    const handleRefresh = () => {
        setHasTriedLoading(false);
        getTryOnHistory(shopId, "");
    };

    useEffect(() => {
        if (!isLoadingProducts && products.length > 0 && loadStoryState) {
            openStoriesView();
            setLoadStoryState(false);
        }
    }, [isLoadingProducts, products, loadStoryState]);

    useEffect(() => {
        if (!isLoadingProducts) {
            setHasTriedLoading(true);
        }
    }, [isLoadingProducts]);

    // Auto-reload effect: Check if any product has status "in progress" and reload after 25 seconds
    useEffect(() => {
        // Clear any existing timer when products change
        if (autoReloadTimer) {
            clearTimeout(autoReloadTimer);
            setAutoReloadTimer(null);
        }

        // Check if any product has status "in progress" (case-insensitive)
        const hasInProgressProducts = products.some(product => 
            product.status && product.status.toLowerCase() === 'processing'
        );

        if (hasInProgressProducts && !isLoadingProducts) {
            console.log('Found try-on(s) in progress, will reload in 25 seconds...');
            
            // Set up a timer to reload after 25 seconds
            const timer = setTimeout(() => {
                console.log('Auto-reloading try-on history...');
                getTryOnHistory(shopId, "");
                setProductModeState("STORIES");
            }, 25000); // 25 seconds

            setAutoReloadTimer(timer);
        }

        // Cleanup function to clear timer when component unmounts or dependencies change
        return () => {
            if (autoReloadTimer) {
                clearTimeout(autoReloadTimer);
            }
        };
    }, [products, isLoadingProducts, shopId]);
    

  const runSearch = (keyword) => {
    setState({ searchquery: keyword });
    setState({ resetvalue: "" });
    history.push(`/products/search/${keyword}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      runSearch(option.target.innerText);
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {

    }
  };

    const debouncedChangeHandler = useCallback(
        debounce(runKeywordSearch, 300)
        , []);

  const selectKeywordSearch = (value) => {
      history.push(`/products/search/${value}`);
  };

  const handleDelete = () => {
      history.push("/products");
  };


    const addProductFavourite = (prodId) => {
        userMainAddProductToWishlist(prodId);
    };


    // Click on product item from search results
  const handleProductView = (mode, product, index, withStory, reset) => () => {

      if (withStory) {
          setLoadIdState(index);
      }

    setProductModeState(mode);
    if (reset) {
      setProductState({
        selectedProduct: {
            _id: "",
            shop_id: "",
            status: "",
            images: [],
            result_images: [],
            video: [],
            title: "",
            logo: [],
            area: "",
        },
      });
    } else {

        analyticsTrackEvent("User Interaction", "Main Product Clicked : Story - " + withStory, product.title + " " + product.shop_id + " " + product._id);

        //userMainGetProductInfo(product._id);
      setProductState({
          selectedProduct: {
            _id: product._id,
              shop_id: product.shop_id,
            status: product.status,
            images: product.images,
            result_images: product.result_images,
            video: product.video,
            title: product.title,
            logo: product.logo,
            area: product.area,
        },
      });
    }
  };

    const handleViewShop = (product, index) => {
        setProductModeState("VIEWDETAIL");
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", product.shop_id, "", ""));
    };

    // Click on product item from stories player
    const handleBuyProduct = (product, index) => {

        userMainGetProductInfo(product._id);
        setProductState({
            selectedProduct: {
                _id: product._id,
                shop_id: product.shop_id,
                status: product.status,
                images: product.images,
                video: product.video,
                title: product.title,
                logo: product.logo,
                area: product.area,
            },
        });

        setProductModeState("VIEWDETAIL");
    };

    const openCategoryList = () => {
        setProductModeState("CATEG");
    };

    const openStoriesView = () => {
        setProductModeState("STORIES");
    };


    const handlePrevOffset = () => {
        const offset = offsetState > 1 ? offsetState - 1 : 0;
        setOffsetState(offset);
        setHasTriedLoading(false);
        getTryOnHistory(shopId);
    };

    const handleNextOffset = () => {
        const offset = offsetState + 1;
        setOffsetState(offset);
        setHasTriedLoading(false);
        getTryOnHistory(shopId);
    };

    const handleResetResultsStory = () => {
        setProductModeState("PREVIEW");
        setLoadIdState("");
    };

    const handleResetProductStory = () => {
        setLoadIdState("");
    };

    const handleDeleteClick = (tryonId) => {
        setTryonToDelete(tryonId);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (tryonToDelete) {
            deleteTryOn({ tryonId: tryonToDelete });
            setDeleteDialogOpen(false);
            setTryonToDelete(null);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setTryonToDelete(null);
    };

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/products/search")) {
      history.push("/products/search");
    }
  };


  const renderNoResults = () => (
      <Container>
        <Box>
            <Typography variant="h6">
                No item found
            </Typography>
        </Box>
      </Container>
  );

    const handleLongPress = (product, index) => () => {

        // ignore action for now

        /*
        setShowModalProduct(product);

        userMainGetProductInfo(product._id);

        setProductState({
            selectedProduct: {
                _id: product._id,
                shop_id: product.shop_id,
                status: product.status,
                images: product.images,
                video: product.video,
                title: product.title,
                logo: product.logo,
                area: product.area,
            },
        });

         */

    };


  const renderResults = () => (
      <div>
          {/*isFeatureSupported("shopreels") &&
              <CustomFlexBox sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'fixed',
                  width: '100%',
                  bottom: 70,
                  justifyContent: 'center',
                  zIndex: 'modal'
              }}>
                  <Button
                      sx={{marginRight: '2px'}}
                      size="large"
                      color="primary"
                      variant="contained"
                      onClick={openStoriesView}
                  >
                      <SlideshowIcon /> &nbsp; View as {process.env.REACT_APP_REELS_TAG}
                  </Button>
              </CustomFlexBox>
          */}

          { includeHeader && <CustomSectionCreator
        icon={<PeopleAltIcon sx={{ color: '#E53E3E', mr: 1 }} />} 
        title='My Try-Ons' 
      />}
          <Box className="credits-display-banner" mb={3} mt={2}>
              <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
                  <Box>
                      <H4 fontSize={14} color="textSecondary">Available Credits</H4>
                      <H2 fontSize={24} fontWeight="bold" color="primary">
                          {tryonCredits ? tryonCredits.balance || 0 : 0}
                      </H2>
                  </Box>
              </Box>
          </Box>
          <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
              {products.map((product, index) => (
                  <Grid item xs={6} sm={3} md={3} lg={3} key={index}>
                      <UnifiedLongPressableObject item={product} index={index}
                                                  onLongPress={handleLongPress(product, index)}>


                          <UserTryOnItem
                              tryon={product}
                              viewProductWithStory={handleProductView("STORIES", product, index, true, false)}
                            onDelete={handleDeleteClick}
                          />

                      </UnifiedLongPressableObject>
                  </Grid>
              ))}
          </Grid>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
        <DialogTitle>Delete Try-On</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this virtual try-on? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      </div>
  );

    const storiesData = products.map((product, index) => {
        const {id, shop_id, result_images, video, title, logo, area, product_id} = product;

        let stories = [];

        // Use result_images if available (generated images), otherwise fallback to product images
        const imagesToDisplay = (result_images && result_images.length > 0) ? result_images : product_id?.images;

        if (video && video.length > 0) {
            const fallbackImage = imagesToDisplay && imagesToDisplay.length > 0 
                ? (imagesToDisplay[0].full_size_cdn ? imagesToDisplay[0].full_size_cdn.secure_url : imagesToDisplay[0].cdn.secure_url)
                : "";
            stories.push({
                video: video[0].cdn.secure_url,
                videoimage: fallbackImage
            });
        } else {
            imagesToDisplay && imagesToDisplay.map((image) => (
                stories.push({
                    image: image.full_size_cdn ? image.full_size_cdn.secure_url : image.cdn.secure_url,
                })
            ));
        }


        return (
            {
                user: {
                    avatar: "",
                    name: title || "",
                    linkTitle1: "",
                    linkTitle2: "",
                },
                item: product,
                itemIndex: index,
                stories: stories,
            }
        );
    });

    const renderResultsAsStories = () => (
        <div>
            <StoriesPlayer
                loadIndex={loadIdState}
                storiesData={storiesData}
                /*setAsFav={addProductFavourite}*/
                onButton1Click={handleViewShop}
                onButton2Click={handleBuyProduct}
                onIndexChange={(index) => setCurrentStoryIndex(index)}
                onCancel={() => handleResetResultsStory()}
            />
            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
                /*onRightSwipeComplete={() => handleBuyProduct(products[currentStoryIndex], currentStoryIndex)}*/
            />
        </div>
    );

    const renderProductDetail = () => (
        <>
            <UserProductDetail
                setState={(value, field) => setProductState({
                    ...state,
                    selectedProduct: {
                        ...selectedProduct,
                        [field]: value,
                    },
                })}
                currency={currency}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToFavlistClicked={addProductFavourite}
                history={history}
                onCancel={() => setProductModeState("PREVIEW")}
                wholesale={wholesale}
            />

            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
            />
        </>
    );

    const renderProductModal = () => (
        <>
            <UserProductDetailModal
                setState={(value, field) => setProductState({
                    ...state,
                    selectedProduct: {
                        ...selectedProduct,
                        [field]: value,
                    },
                })}
                currency={currency}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToFavlistClicked={addProductFavourite}
                history={history}
                onCancel={() => setProductModeState("PREVIEW")}
                excludeHome={wholesale}
                wholesale={wholesale}
            />
        </>
    );

    const renderProductWithStoriesPlayer = (productData) => (

        <div>

            {renderProductDetail()}

            <StoriesPlayer
                storiesData={productData}
                onCancel={() => handleResetProductStory()}
                setAsFav={addProductFavourite}
                onButton1Click={handleViewShop}
                onButton2Click={handleBuyProduct}
                onIndexChange={(index) => setCurrentStoryIndex(index)}
            />
        </div>

    );

  const renderSearchResults = () => (
    <>
      <Container>
      { match.path !== "/"
      && (
          match.path === "/shopping/mytryons" ||
          match.path === "/account/mytryons" ||
          match.path === "/shop/:shopId/account/mytryons"
      ) && (
      <>
          {isLoadingProducts ? (
              <MockSearchResults />
          ) : products.length > 0 ? (
              renderResults()
          ) : hasTriedLoading ? (
              renderNoResults()
          ) : null}
      </>
      )}
      </Container>
    </>
  );

  const renderProductMode = (productMode) => {
    switch (productMode) {

        case "STORIES":
            return renderResultsAsStories();


        case "STORIESVIEW":

            const {id, shop_id, result_images, video, title, logo, area, product_id} = selectedProduct;

            let productStoryData = [];
            let stories = [];

            // Use result_images if available (generated images), otherwise fallback to product images
            const selectedImagesToDisplay = (result_images && result_images.length > 0) ? result_images : product_id?.images;

            if (video && video.length > 0) {
                const fallbackImageUrl = selectedImagesToDisplay && selectedImagesToDisplay.length > 0
                    ? (selectedImagesToDisplay[0].full_size_cdn ? selectedImagesToDisplay[0].full_size_cdn.secure_url : selectedImagesToDisplay[0].cdn.secure_url)
                    : "";
                stories.push({
                    video: video[0].cdn.secure_url,
                    videoimage: fallbackImageUrl
                });
            } else {
                selectedImagesToDisplay && selectedImagesToDisplay.map((image) => (
                    stories.push({
                        image: image.full_size_cdn ? image.full_size_cdn.secure_url : image.cdn.secure_url,
                    })
                ));
            }


            productStoryData.push(
                {
                    user: {
                        avatar: "",
                        name: title || "",
                        linkTitle1: "",
                        linkTitle2: "",
                    },
                    stories: stories,
                }
            );

            return renderProductWithStoriesPlayer(productStoryData);

        case "VIEWDETAIL":
            return renderProductDetail();

        case "PREVIEW":
        default:
            return renderSearchResults();
    }
  };

  const { selectedProduct = {} } = productState;

  return (
      <Container>

                {productModeState === "PREVIEW" ? (
                  <UnifiedPullToRefresh
                    onRefresh={handleRefresh}
                    isRefreshing={isLoadingProducts}
                  >
                    {renderProductMode(productModeState)}
                  </UnifiedPullToRefresh>
                ) : (
                  renderProductMode(productModeState)
                )}

          <Modal
              open={!!showModalProduct}
              onClose={closeProductModal}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{ timeout: 300 }}
          >
              <Fade in={!!showModalProduct}>
                  <Box>
                      <IconButton
                          onClick={closeProductModal}
                          sx={{
                              position: 'absolute',
                              bottom: '80%',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              zIndex: 1301,
                              backgroundColor: 'black',
                              color: 'white',
                              width: 48,
                              height: 48,
                              pointerEvents: 'auto',
                              '&:hover': {
                                  backgroundColor: 'grey.800',
                              },
                          }}
                      >
                          <CloseIcon />
                      </IconButton>
                      <Box
                          sx={{
                              position: 'absolute',
                              top: '8%',
                              height: '95%',
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                          }}
                      >
                          <Box sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              width: '96%',
                              overflow: 'hidden',
                              boxSizing: 'border-box',
                              bgcolor: 'background.paper',
                              borderRadius: 2,
                              boxShadow: 24,
                              p: 2,
                          }}>
                              <UnifiedPullDown onPullDown={closeProductModal} threshold={60}>
                                  {renderProductModal()}
                              </UnifiedPullDown>
                          </Box>
                          <UnifiedSwipeTrigger
                              onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
                          />
                      </Box>
                  </Box>
              </Fade>
          </Modal>

      </Container>
  );


};

UserTryoutHistory.defaultProps = {
  currency: "",
};

UserTryoutHistory.propTypes = {
    currency: PropTypes.string,
    bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
    products: PropTypes.arrayOf(PropTypes.any).isRequired,
    searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    commonCategoryList: PropTypes.objectOf(PropTypes.any).isRequired,
    commonColorList: PropTypes.objectOf(PropTypes.any).isRequired,
    citylocations: PropTypes.objectOf(PropTypes.any).isRequired,
    userMainSearchProducts: PropTypes.func.isRequired,
    userMainSearchKeywords: PropTypes.func.isRequired,
    userMainResetsearchKeywords: PropTypes.func.isRequired,
    userMainResetSearchProducts: PropTypes.func.isRequired,
    userMainGetProductInfo: PropTypes.func.isRequired,
    userMainAddProductToWishlist: PropTypes.func.isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const userTryoutHistory = connect(
  ({ userMainProducts, userbootupInfo, bootupInfo, userMainShops }) => ({
      bootupInfo,
      userDetails: bootupInfo.userDetails,
      currency: bootupInfo.symbol,
      reqStatus: userMainProducts.reqStatus,
      serviceError: userMainProducts.serviceError,
      productdetail: userMainProducts.productdetail,
      shopDetail: userMainShops.shopDetail,
      isLoadingShop: userMainShops.isLoading,
      isLoadingProducts: userbootupInfo.isLoading,
      products: userbootupInfo?.tryonHistory?.history || [],
      tryonCredits: userbootupInfo.tryonCredits,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserTryoutHistory);

export { userTryoutHistory as default };
